export const generateNewFilter = (currentFilter, newValues) => {
  return {
    ...Object.keys(currentFilter).reduce((reduced, key) => ({ ...reduced, [key]: newValues }), {})
  }
}
